<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">NOVO ATENDIMENTO</li>
                </ol>

                <div class="col-md-3"></div>

                <div class="col-md-9" v-if="atendimento">

                    <div class="row">

                            <div class="panel panel-info">
                                <!-- Default panel contents -->
                                <div class="panel-heading">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS DO ATENDIMENTO
                                </div>
                                <div class="panel-body row">

                                    <div class="col-sm-6">
                                        <div class="row">

                                            <div class="col-sm-12" v-if="atendimento.contrato">
                                                <label for="nome" class="control-label">NOME DO CLIENTE</label>
                                                <input id="nome" disabled type="text" v-model="atendimento.contrato.cliente.nome" class="form-control" >
                                            </div>

                                            <div class="col-sm-12">
                                                <label class="control-label">MOTIVO DA LIGAÇÃO</label>
                                                <combo-atendimento-motivo v-model="atendimento.motivo._id"/>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="col-sm-6">
                                        <div class="row" style="border-left: #1b1e21 dotted 1px">

                                            <div class="col-sm-12">
                                                <label class="control-label">AÇÕES REALIZADAS:</label>
                                                <combo-atendimento-acoes v-model="acao"/>
                                            </div>

                                            <div class="col-sm-6">
                                                <label class="control-label">&nbsp;</label><br/>
                                                <a :disabled="!acao" @click.prevent="add" class="btn btn-block btn-success">
                                                    ADICIONAR
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="col-sm-12">
                                        <label class="control-label">OBSERVAÇÃO</label>
                                        <textarea class="form-control" rows="5" v-model="atendimento.obs"></textarea>
                                    </div>

                                </div>
                            </div>
                            <div class="panel panel-info">
                                <div class="panel-heading">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i> AÇÕES
                                </div>
                                <div class="panel-body row">

                                    <div class="col-sm-12">
                                        <table id="mytable" class="table table-bordred table-striped">

                                            <thead>
                                                <tr>
                                                    <th >NOME</th>
                                                    <th style="text-align: center;width: 100px">AÇÕES</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-bind:key="r._id" v-for="r in atendimento.acoes">
                                                    <td>{{ r.nome }}</td>
                                                    <td style="text-align: center">
                                                        <button @click="remove(r._id)" class="btn btn-danger btn-xs">
                                                            remover <i class="fa fa-remove" aria-hidden="true"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>

                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-10">
                                    <button type="button" :disabled="!itsOK" @click="save()" class="btn btn-success">
                                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR ATENDIMENTO
                                    </button>
                                </div>
                            </div>

                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import { Contratos, Atendimento } from "../../class/index";
import ComboAtendimentoAcoes from "../../components/combo/atendimento-acoes.vue";
import ComboAtendimentoMotivo from "../../components/combo/atendimento-motivo.vue";

export default {
    name: "Atendimento",
    components: {
        ComboAtendimentoAcoes,
        ComboAtendimentoMotivo
    },
    data() {
        return {
            contrato: null,
            atendimento: Atendimento.create(),
            acao: null
        };
    },
    computed: {
        itsOK: function() {
            if (!this.atendimento) {
                return false;
            }
            if (!this.atendimento.contrato) {
                return false;
            }
            if (!this.atendimento.acoes.length) {
                return false;
            }
            if (!this.atendimento.motivo._id) {
                return false;
            }

            return true;
        }
    },
    beforeMount() {
        if (this.$route.params.id_contrato) {
            this.loadContrato(this.$route.params.id_contrato);
        }
    },
    methods: {
        async loadContrato(id) {
            this.atendimento.contrato = await Contratos.byID(id);
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o atendimento?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Atendimento.save(this.atendimento)
                                .then(() => {
                                    resolve();
                                    this.$router.push({
                                        path:
                                            "/contrato/add/" +
                                            this.atendimento.contrato._id
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },
        add() {
            if (this.acao) {
                this.atendimento.acoes.push(this.acao);
                this.acao = null;
            }
        },
        remove(id) {
            for (let p in this.atendimento.acoes) {
                if (this.atendimento.acoes[p]._id === id) {
                    this.atendimento.acoes.splice(p, 1);
                }
            }
        }
    }
};
</script>

<style scoped>
</style>
